export const Frequencies = {
  weekly: 'Weekly',
  fortnightly: 'Fortnightly',
  monthly: 'Monthly',
};

export const LoanTypes = {
  SACC: 'Mini Flash Loan',
  MACC: 'Super Flash Loan',
};

export const DurationBounds = [
  {min: -Infinity, max: 500, months: 3},
  {min: 500, max: 1000, months: 6},
  {min: 1000, max: 1500, months: 9},
  {min: 1500, max: 2000, months: 12},
  {min: 2000, max: 3500, months: 18},
  {min: 3500, max: Infinity, months: 24},
];

export const LoanPurposes = [
  {
    description: "Vehicle expenses"
  },
  {
    description: "Purchases"
  },
  {
    description: "Utility bills",
    warn: 'It can be useful to talk to your utility provider and see if you can work out a payment plan with them.',
  },
  {
    description: "Travel & entertainment"
  },
  {
    description: "Event expenses"
  },
  {
    description: "Medical expenses",
    isMedical: true,
  },
  {
    description: "Veterinary"
  },
  {
    description: "Educational"
  },
  {
    description: "Professional services fees"
  },
  {
    description: "Home moving & maintenance"
  },
  {
    description: "Debt consolidation",
    warn: 'It can be useful to talk to your credit provider and see if you can work out a payment plan with them.',
  },
  {
    description: "Other",
    warn: 'We may give you a call to confirm'
  }
];

export const Genders = {
  M: 'Male',
  F: 'Female',
};

export const Titles = {
  Mr: 'Mr',
  Mrs: 'Mrs',
  Ms: 'Ms',
  Dr: 'Dr',
  Miss: 'Miss',
};

export const IDVerificationDocumentTypes = {
  passport: 'Passport',
  license: 'Driving Licence',
};

export const StatesOfAustralia = {
  NSW: 'NSW',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA',
  QLD: 'QLD',
  NT: 'NT',
  ACT: 'ACT',
};

export const MedicareCardColors = {
  B: 'Blue',
  G: 'Green',
  Y: 'Yellow',
};

export const EmploymentStatus = {
  'Part Time': 'Part Time',
  'Full Time': 'Full Time',
  'Casual': 'Casual',
  'Contract': 'Contract',
  'Self Employed': 'Self Employed',
  'Government Benefits': 'Government Benefits',
};

export const MaritalStatus = {
  Single: 'Single',
  Defacto: 'Defacto',
  Married: 'Married',
  Separated: 'Separated',
  Divorced: 'Divorced',
  Widowed: 'Widowed',
};

export const ResidentialStatus = {
  'Mortgage': 'Mortgage',
  'Renting': 'Renting',
  'Owned': 'Owned',
  'Boarding': 'Boarding',
  'Living with Parents': 'Living with Parents',
};
